import React, { useEffect, useState } from "react";

function NewBusinessClientListByIndustry({ onclose, table_data }) {
  console.log(table_data);
  const [data, setData] = useState([]);
  const REACT_APP_PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  useEffect(() => {
  const grouped = table_data?.reduce((acc, item) => {
    if (!acc[item.industry]) {
      acc[item.industry] = [];
    }
    acc[item.industry].push({
      client_name: item.name,
      logo: item.logo,
    });
    return acc;
  }, []);

  setData(grouped);
}, [table_data]);
  return (
    <>
      <div className="modal fade show d-block" tabIndex={-1}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">New Business Clients Industries</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onclose}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                {Object.keys(data).map((industry, index) => (
                  <>
                    <div className="col-md-12" key={index}>
                      <h5>
                        <u>{industry}</u>
                      </h5>
                      <div
                        className="row d-flex mt-2 mb-2"
                        style={{ flexDirection: "row", flexWrap: "wrap" }}
                      >
                        {data[industry].map((client, index) => (
                          <div
                            className="col-md-3 mb-2 text-center p-2"
                            key={index}
                          >
                            <div className="avatar avatar-xl m-auto d-flex mb-2 my-custom-client-logo-box p-2">
                              <img
                                src={`${REACT_APP_PINE_BASE_URL}/files/companyLogo/${client.logo}`}
                                alt={client.client_name}
                                className="client-logo"
                                style={{
                                  width: "100px !important",
                                  height: "100px !important",
                                }}
                              />
                            </div>
                            <div className="col-md-12 text-center">
                              <h6>{client.client_name}</h6>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <hr style={{ opacity: "1" }} />
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewBusinessClientListByIndustry;
